import { IconType } from "Icons/types";

import { ReactNode } from "react";

import { css } from "@emotion/react";

import { ButtonWrapper } from "components/shared/library/ButtonWrapper";
import { Typography } from "components/shared/library/Typography";

import { purple, uiGray, white } from "constants/colors";

export type Props = {
  id?: string;
  Icon?: IconType;
  LeftComponent?: ReactNode;
  label: string;
  onClick: () => void;
  color?: string;
  justify?: string;
  unfocusAfterClick?: boolean;
  description?: string;
  descriptionColor?: string;
};

const getStyle = (justify: string) => {
  return {
    wrapperStyle: css({
      display: "flex",
      alignItems: "center",
      justifyContent: justify,
      background: white,
      padding: "8px 12px",
      borderRadius: 8,
      width: "100%",
      "&:hover": { background: purple[50] },
      "&:focus": {
        outline: "none",
        boxShadow: `0px 0px 0px 4px ${purple.focusShadow}`,
      },
    }),
    labels: css({
      display: "flex",
      flexDirection: "column",
    }),
    typography: css({ marginLeft: 8 }),
  };
};

export const MenuBarAction = ({
  id,
  onClick,
  label,
  Icon,
  LeftComponent,
  color = uiGray[60],
  justify = "normal",
  unfocusAfterClick = false,
  description,
  descriptionColor = uiGray[60],
}: Props) => {
  const style = getStyle(justify);

  return (
    <ButtonWrapper
      id={id}
      onClick={(e) => {
        onClick();
        if (unfocusAfterClick) {
          e.currentTarget.blur();
        }
      }}
      customCss={style.wrapperStyle}
      ariaLabel={label}
    >
      {LeftComponent}
      {Icon && <Icon stroke={color} width={16} height={16} />}
      <div css={style.labels}>
        <Typography
          customCss={style.typography}
          weight="medium"
          size="XS"
          color={color}
        >
          {label}
        </Typography>
        {description && (
          <Typography
            customCss={style.typography}
            size="XXS"
            color={descriptionColor}
          >
            {description}
          </Typography>
        )}
      </div>
    </ButtonWrapper>
  );
};
